import React from 'react';
import { trackEvent } from '@kcd/event-tracker';

import { Chip } from '~/components/Chip';
import { useUpdateRouterQuery } from '~/hooks/url';

import { useRecommendSearchKeywords } from '../keyword/queries';

export function PopularSearchKeywordList() {
  const updateRouterQuery = useUpdateRouterQuery();

  const [value] = useRecommendSearchKeywords();

  const onClickRecommendkeyword = (keyword: string) => {
    trackEvent('clicked tab in 마켓/검색', {
      keyword,
      clicked_area: '인기 검색어',
    });
    void updateRouterQuery({
      searchText: keyword,
    });
  };

  return (
    <div>
      <div className="mb-12 flex justify-between px-20  text-paragraph typo-caption100-regular">
        <h2 className="typo-caption100-semibold">인기 검색어</h2>
      </div>
      <div className="flex flex-wrap gap-8 px-20">
        {value?.recommendKeywords.map((keyword) => (
          <Chip
            key={keyword}
            onClick={() => {
              onClickRecommendkeyword(keyword);
            }}
          >
            {keyword}
          </Chip>
        ))}
      </div>
    </div>
  );
}
